import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { BigLink } from './index'
import { connect } from 'react-redux'
import { selectLoggedIn } from 'services/user/selectors'
import * as consentActions from 'services/consents/actions'

const mapStateToProps = (state) => ({
  isLoggedIn: selectLoggedIn(state),
})

const mapDispatchToActions = {
  ...consentActions,
}

function PrivacyLinks (props) {
  const {
    accountDelete,
    editConsents,
    exportData,
    contactSupport,
    logout,
    isMobile,
    isLoggedIn,
    clickExportDataHelp,
    stageConsentSource,
    screenName,
  } = props

  stageConsentSource(screenName)
  return (
    <div>
      { editConsents ?
        <BigLink
          destination={isMobile ? null : '/privacy_center/consents/edit'}
          href={isMobile ? '/mobile/privacy_center/consents/edit' : null}
        >
          <FormattedMessage id='privacy_center.links.data_consents' defaultMessage="Data Consents" />
        </BigLink>
      : null }

      { exportData ?
        <BigLink href='https://support.mapmyfitness.com/hc/articles/200118594'
          analyticsEvent={clickExportDataHelp} screenName={screenName}>
          <FormattedMessage id='privacy_center.links.export_data' defaultMessage="Export Data Help" />
        </BigLink>
      : null }

      { accountDelete && isLoggedIn ?
        <BigLink
          destination={isMobile ? null : '/account/delete'}
          href={isMobile ? '/mobile/account/delete' : null}
        >
          <FormattedMessage id='privacy_center.links.delete_account' defaultMessage="Delete Account" />
        </BigLink>
      : null }

      { contactSupport ?
        <BigLink href='https://support.mapmyfitness.com/hc/requests/new'>
          <FormattedMessage id='privacy_center.links.contact_support' defaultMessage="Contact Support" />
        </BigLink>
      : null }

      { logout && isLoggedIn ?
        <BigLink href='/auth/logout'>
          <FormattedMessage id='privacy_center.links.logout' defaultMessage="Log Out" />
        </BigLink>
      : null }
    </div>
  )
}

PrivacyLinks.propTypes = {
  accountDelete: PropTypes.bool,
  contactSupport: PropTypes.bool,
  editConsents: PropTypes.bool,
  exportData: PropTypes.bool,
  logout: PropTypes.bool,
  isMobile: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  clickExportDataHelp: PropTypes.func,
  stageConsentSource: PropTypes.func,
  screenName: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToActions)(PrivacyLinks)



// WEBPACK FOOTER //
// ./src/components/privacy_center/util/PrivacyLinks.jsx